import { render, staticRenderFns } from "./WishListTable.vue?vue&type=template&id=10973830&scoped=true"
import script from "./WishListTable.vue?vue&type=script&lang=js"
export * from "./WishListTable.vue?vue&type=script&lang=js"
import style0 from "./WishListTable.vue?vue&type=style&index=0&id=10973830&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10973830",
  null
  
)

export default component.exports